<div>
  <div class="form-body">
    <h1>{{ translationService.getProductGhsClassificationInformation() }}</h1>
    <p>{{ translationService.getPleaseSelectProjectGhsSymbols() }}</p>
    <app-ghs-select
      [selected]="selected"
      (selectChange)="handleChange($event)"
    ></app-ghs-select>
  </div>

  <div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.getBackText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </div>
</div>
